import React, { useState, useContext,useRef , useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import 'bootstrap/dist/css/bootstrap.min.css'; 
import { UserContext } from "../UserContext";
import ConnString from "../../../../ConnString.js";
import { Stack,useTheme  } from "@mui/material";
import { tokens, ColorModeContext } from "../../../../theme.js";
import {getSessionUser} from "../../../../useSession.js";
 

const Connstring2 = ConnString.connstring;

const CompanyList = ({ companies, dateFrom, dateTo, refreshCompanies }) => {

        const theme = useTheme();
        const colors = tokens(theme.palette.mode);
    
        const mode = theme.palette.mode; // "light" | "dark"
 
        const t = (group, shade, fallback) => {
        return colors?.[group]?.[shade] ?? fallback;
        };
            
        useContext(ColorModeContext);
            
    const { userEmail } = getSessionUser();

   // const [userEmail, setUserEmail] = useState(sessionStorage.getItem("userEmail"));
    const [isSaving, setIsSaving] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filter, setFilter] = useState('all');
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [updatingCompany, setupdatingCompany] = useState([]);
    const [newStatus, setNewStatus] = useState('');
    const [remarks, setRemarks] = useState('');
    const [showModal, setShowModal] = useState(false);

     const [isFullscreen, setIsFullscreen] = useState(false);
      const [hoveredCellId, setHoveredCellId] = useState(null);
        const matrixRef = useRef(null);

    const compID = sessionStorage.getItem("compID");
    const userID = sessionStorage.getItem("userID");
     
    const { username, setUsername } = useContext(UserContext);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10; // Limit rows per page

     const STATUS_THEME_COLORS = {
        Done: {
            light: t("greenAccent", 500, theme.palette.success.light),
            dark: t("greenAccent", 700, theme.palette.success.dark),
        },
        Updated: {
            light: t("blueAccent", 500, theme.palette.info.light),
            dark: t("blueAccent", 700, theme.palette.info.dark),
        },
        Drafted: {
            light: t("blueAccent", 300, theme.palette.info.light),
            dark: t("blueAccent", 900, theme.palette.info.dark),
        },
        Pending: {
            light: t("blueAccent", 300, theme.palette.info.light),
            dark: t("blueAccent", 900, theme.palette.info.dark),
        },
        "For Payment": {
            light: t("greenAccent", 300, theme.palette.info.light),
            dark: t("greenAccent", 800, theme.palette.info.dark),
        },
        "To Do": {
            // orangeAccent may not exist in your tokens -> fallback to warning palette
            light: t("orangeAccent", 500, theme.palette.warning.light),
            dark: t("orangeAccent", 700, theme.palette.warning.dark),
        },
            };

   const statusColor = (status) =>
     STATUS_THEME_COLORS[status]?.[mode] ?? theme.palette.background.default;

        const statusTextColor = () =>
        mode === "dark" ? theme.palette.grey[100] : theme.palette.grey[900];

   const statusHoverColor = (status) => {
    switch (status) {
        case "Done":
        return mode === "dark"
            ? t("greenAccent", 700, theme.palette.success.main)
            : t("greenAccent", 400, theme.palette.success.light);

        case "Pending":
        return mode === "dark"
            ? t("blueAccent", 200, theme.palette.info.main)
            : t("blueAccent", 800, theme.palette.info.light);

            case "For Payment":
            return mode === "dark"
            ? t("greenAccent", 200, theme.palette.info.main)
            : t("greenAccent", 800, theme.palette.info.light);

            case "Updated":
            return mode === "dark"
            ? t("blueAccent", 700, theme.palette.info.main)
            : t("blueAccent", 400, theme.palette.info.light);

            case "Drafted":
                return mode === "dark"
                ? t("blueAccent", 800, theme.palette.info.main)
                : t("blueAccent", 200, theme.palette.info.light);
    

                            
        case "To Do":
        return mode === "dark"
            ? t("orangeAccent", 700, theme.palette.warning.main)
            : t("orangeAccent", 400, theme.palette.warning.light);

        default:
        return undefined;
    }
    };

    
      const enterFullscreen = () => {
      if (!matrixRef.current) return;
      const el = matrixRef.current;
    
      if (el.requestFullscreen) el.requestFullscreen();
      else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen(); // Safari
        };
        
            const exitFullscreen = () => {
            if (document.exitFullscreen) document.exitFullscreen();
            else if (document.webkitExitFullscreen) document.webkitExitFullscreen(); // Safari
            };
        
            useEffect(() => {
            const onChange = () => {
                const fsEl = document.fullscreenElement || document.webkitFullscreenElement;
                setIsFullscreen(Boolean(fsEl));
            };
        
            document.addEventListener("fullscreenchange", onChange);
            document.addEventListener("webkitfullscreenchange", onChange);
        
            return () => {
                document.removeEventListener("fullscreenchange", onChange);
                document.removeEventListener("webkitfullscreenchange", onChange);
            };
            }, []);
        

    const navigate = useNavigate();

    const handleStatusChange = (e) => {
        setNewStatus(e.target.value);
    };

    const handleRemarksChange = (e) => {
        setRemarks(e.target.value);
    };

    const markUpdate = (ID,Companyname,Returnx,Deadline) => {
        console.log('Updating Company with RecID:', ID); // Log the RecID to see if it exists
        setSelectedCompany(ID); // Set selected company
        setupdatingCompany({"name": Companyname,"return": Returnx,"dealdine":Deadline})
        setNewStatus(''); // Reset status
        setRemarks(''); // Reset remarks
        setShowModal(true); // Show the modal
    };
    
    const handleUpdate = async (e) => {
            e?.preventDefault?.(); // ✅ if called from a form submit
            e?.stopPropagation?.(); // ✅ prevents bubbling to parent click handlers

            if (isSaving) return;   // ✅ prevents multi-click / double-fire
            setIsSaving(true);

            try {
            if (!selectedCompany) {
            alert("Please select a company.");
            return;
            }

    const snewstatus = newStatus;
    const sremarks = remarks;
   // const suser = username || "System";

 
     
    const suser = sessionStorage.getItem("userEmail");

  

    if (!snewstatus || !sremarks) {
      alert("Missing status or remarks.");
      return;
    }

    const response = await fetch(`${Connstring2}/api/updatetask3/${selectedCompany}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        companyID: compID,
        newStatus: snewstatus,
        remarks: sremarks,
        user: suser,
      }),
    });

    if (!response.ok) throw new Error(await response.text());

    alert("Task updated successfully!");
    setShowModal(false);
    refreshCompanies();
  } catch (error) {
    console.error("Error updating task:", error);
    alert("Failed to update task. Please try again.");
  } finally {
    setIsSaving(false);
  }
};

    const searchItems = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    // Filtered companies based on the search term and filter
    const filteredCompanies = companies
        .filter(company => {
            const CompanyName = company.CompanyName || '';
            return CompanyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                CompanyName.includes(searchTerm);
        })
        .filter(company => filter === 'all' || company.SQLDBName === filter);

    const totalPages = Math.ceil(filteredCompanies.length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const paginatedCompanies = filteredCompanies.slice(startIndex, startIndex + rowsPerPage);

    const maxPagesToShow = 10;
    let startPage, endPage;

    if (totalPages <= maxPagesToShow) {
        startPage = 1;
        endPage = totalPages;
    } else {
        const maxPagesBeforeCurrentPage = Math.floor(maxPagesToShow / 2);
        const maxPagesAfterCurrentPage = Math.ceil(maxPagesToShow / 2) - 1;

        if (currentPage <= maxPagesBeforeCurrentPage) {
            startPage = 1;
            endPage = maxPagesToShow;
        } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
            startPage = totalPages - maxPagesToShow + 1;
            endPage = totalPages;
        } else {
            startPage = currentPage - maxPagesBeforeCurrentPage;
            endPage = currentPage + maxPagesAfterCurrentPage;
        }
    }

    const pages = Array.from({ length: (endPage - startPage + 1) }, (_, i) => startPage + i);

    const changePage = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
           <div style={styles.CenterSection} backgroundColor={colors.primary[400]}>
            <div style={styles.contentWrapper}>
                <div style={styles.inventorycontrols} backgroundColor={colors.primary[400]}>
                <Stack   justifyContent="space-between" alignItems="center" spacing={1} backgroundColor={colors.primary[400]}  sx={{ flexGrow: 1 }}>
                
                    <h3>LIST</h3>
                    <input
                        type="text"
                        id="searchInput"
                        placeholder="Search Company..."
                        value={searchTerm}
                        onChange={searchItems}
                        style={{ width: '500px',height: "30px" }}
                    />
                  
                    </Stack>
              </div>

                <div 
          
                  style={{
                    ...styles.tableContainer,
                    ...(isFullscreen ? styles.fullscreenContainer : {}),
                    backgroundColor: colors.primary[400],
                }}
                
                >
                    <table id="companyListTable" style={styles.table} backgroundColor={colors.primary[400]}>
                        <thead>
                            <tr>
                                <th style={{ ...styles.th, textAlign: "center", minWidth: 50,backgroundColor: colors.primary[400] } } >RecID</th>

                               
                                <th style={{ ...styles.th, textAlign: "center", minWidth: 80,backgroundColor: colors.primary[400] }}>Period</th>
                                <th  style={{ ...styles.th, textAlign: "center", minWidth: 80,backgroundColor: colors.primary[400] }}>Deadline</th>
                                <th style={{ ...styles.th, textAlign: "center", minWidth: 80,backgroundColor: colors.primary[400] } } >Return</th>
                                <th style={{ ...styles.th, textAlign: "center", minWidth: 120,backgroundColor: colors.primary[400] }}>Assigned</th>
                                <th  style={{ ...styles.th, textAlign: "center", minWidth: 80,backgroundColor: colors.primary[400] }}>Actions</th>
                                <th  style={{ ...styles.th, textAlign: "center", minWidth: 100,backgroundColor: colors.primary[400] }}>Company Name</th>
                                <th style={{ ...styles.th, textAlign: "center", minWidth: 80,backgroundColor: colors.primary[400] }}>TIN</th>
                                <th  style={{ ...styles.th, textAlign: "center", minWidth: 80,backgroundColor: colors.primary[400] }}>Status</th>
                                <th  style={{ ...styles.th, textAlign: "center", minWidth: 80,backgroundColor: colors.primary[400] }}>Remarks</th>

                            </tr>
                        </thead>
                        <tbody>
                            {paginatedCompanies.map((company, index) => (
                               // <tr key={index}
                               <tr key={company.RecID}
                                    style={{
                                        backgroundColor: company.Statusx === 'Done' ? 'lightgreen' : 'transparent'
                                    }}
                                     >
                                    <td style={{ ...styles.td, ...styles.stickyLeft, fontWeight: 600,backgroundColor: colors.primary[400] }}>{company.RecID}</td>
                                  
                                    
                                    <td style={{ ...styles.td, ...styles.stickyLeft, fontWeight: 600,backgroundColor: colors.primary[400] }}>{company.Period}</td>
                                    <td style={{ ...styles.td, ...styles.stickyLeft, fontWeight: 600,backgroundColor: colors.primary[400] }}>{company.Deadline}</td>
                                      <td style={{ ...styles.td, ...styles.stickyLeft, fontWeight: 600,backgroundColor: colors.primary[400] }}>{company.Returnx}</td>
                                    <td style={{ ...styles.td, ...styles.stickyLeft, fontWeight: 600,backgroundColor: colors.primary[400] }}>{company.Assigned || 'Unassigned'}</td>
                                    <button type="button" className="btn btn-info" onClick={() => markUpdate(company.RecID,company.CompanyName,company.Returnx,company.Deadline)}
                                        >Update</button>
                                    <td style={{ ...styles.td, ...styles.stickyLeft, fontWeight: 600,backgroundColor: company.Statusx === 'Done' ? 'lightgreen' : 'transparent'}}>{company.CompanyName}</td>
                                    <td style={{ ...styles.td, ...styles.stickyLeft, fontWeight: 600,backgroundColor: colors.primary[400] }}>{company.CompTIN}</td>
                                    {/* <td style={{ ...styles.td, fontWeight: 'normal', color: company.FStatus === 'Done' ? 'green' : 'black' }}>{company.Statusx}</td> */}
                                     <td style={{ ...styles.td, fontWeight: 'normal', 
                                         backgroundColor:
                                        hoveredCellId === company.RecID
                                            ? statusHoverColor(company.Statusx)
                                            : statusColor(company.Statusx),
                                        color: statusTextColor(company.Statusx) }}>{company.Statusx}</td>
                                    <td style={{ ...styles.td, ...styles.stickyLeft, fontWeight: 600,backgroundColor: colors.primary[400] }}>{company.Remarks}</td>
                                    <td style={{ ...styles.td, ...styles.stickyLeft, fontWeight: 600,backgroundColor: colors.primary[400] }}>
                                  
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div style={styles.pagination}>
                    {startPage > 1 && (
                        <>
                            <button onClick={() => changePage(1)} style={styles.pageButton}>
                                First
                            </button>
                            <button onClick={() => changePage(currentPage - 1)} style={styles.pageButton}>
                                Prev
                            </button>
                        </>
                    )}
                    {pages.map(page => (
                        <button
                            key={page}
                            onClick={() => changePage(page)}
                            disabled={currentPage === page}
                            style={{
                                ...styles.pageButton,
                                backgroundColor: currentPage === page ? '#007bff' : '#f0f0f0',
                                color: currentPage === page ? '#fff' : '#000'
                            }}
                        >
                            {page}
                        </button>
                    ))}
                    {endPage < totalPages && (
                        <>
                            <button onClick={() => changePage(currentPage + 1)} style={styles.pageButton}>
                                Next
                            </button>
                            <button onClick={() => changePage(totalPages)} style={styles.pageButton}>
                                Last
                            </button>
                        </>
                    )}
                </div>
            </div>

            {/* Modal for Updating Status */}
            {showModal && (
                <div className="modal show fade" tabIndex="-1" style={{ display: 'block' }}>
                    {/* <div className="modal-dialog"> */}
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                          
                                <h5 className="modal-title">Update Status</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                {/* <p>Change the status of company ${updatingCompany.name}`:</p> */}
                                <h6>{`Change the status of \nCompany: ${updatingCompany.name}\nReturn: ${updatingCompany.return}\nDeadline: ${updatingCompany.dealdine}`}</h6>
                                <select className="form-select" value={newStatus} onChange={handleStatusChange}>
                                    <option value="">Select Status</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Done">Done</option>
                                    <option value="Drafted">Drafted</option>
                                    <option value="For Payment">For Payment</option>
                                </select>
                                {newStatus && (
                                    <div className="mt-3">
                                        <label>Remarks:</label>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            value={remarks}
                                            onChange={handleRemarksChange}
                                            placeholder="Enter additional remarks here..."
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                                <button type="button" className="btn btn-primary" onClick={handleUpdate} disabled={!newStatus || isSaving}> {isSaving ? "Updating..." : "Update"}</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const styles = {
    CenterSection: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'top',
        height: '100vh',
       // backgroundColor: '#f2f2f2',
    },
    contentWrapper: {
        width: '100%',
        maxWidth: '2000px',
        padding: '20px',
       // backgroundColor: '#ffffff',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        textAlign: 'center',
    },
    inventorycontrols: {
        marginBottom: '20px',
        display: 'flex',
        justifyContent: 'Left',
        gap: '10px',
    },
    tableContainer: {
        maxHeight: '1000px',
        overflowY: 'auto',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
    },
    th: {
        position: 'sticky',
        top: 0,
       // backgroundColor: '#f8f8f8',
        zIndex: 2,
        border: '1px solid #ddd',
        padding: '8px',
        textAlign: 'left',
    },
    td: {
        border: '1px solid #ddd',
        padding: '8px',
        textAlign: 'left',
    },
    pagination: {
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'center',
    },
    pageButton: {
        margin: '0 5px',
        padding: '5px 10px',
        border: '1px solid #ddd',
        cursor: 'pointer',
    },
    stickyLeft: {
    position: "sticky",
    left: 0,
    zIndex: 3,
  },
 
};

export default CompanyList;
